module.exports = __webpack_public_path__ + "static/img/demo-card-dog.5baf3f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo-card-dog.png
// module id = Z3o7
// module chunks = 1